import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { useState } from "react";

const AboutLmp = () => {

    return (
        <section>
            <div className='about-mijsc-section w-full bg-cover h-fit pb-5'>
                <Helmet>
                    <title>About LMP | Our Mission & Vision</title>
                    <meta name="description" content="Learn more about LMP (Lean Manufacturing Practices Programs), its mission, and its role in transforming SMEs through visionary industry-academia collaboration." />
                </Helmet>
                <BreadCrumbs />

                <div className='w-[94%] text-justify'>
                    <section className='w-full h-fit md:mx-10 mx-5 ' >
                        <h1 className="md:text-4xl text-lg mt-10 mb-3 font-semibold text-left capitalize">Lean Manufacturing  <br />
                            <span className="text-green-600">Practices Program</span>
                        </h1>
                    </section>
                </div>

                <section
                    className="mx-5 pb-10 pt-5"
                    aria-label="About MIJSC"
                >
                    <div className="flex flex-col md:flex-row md:gap-2 md:items-center text-left">


                        {/* LEFT: image + floating card */}
                        <div
                            className="relative flex-[0_0_48%] min-w-[280px]"
                            aria-hidden="false"
                        >
                            {/* Main Image */}
                            <img src="/assets/physical-interactions-.png" alt="MIJSC classroom and students" className="w-full h-full object-contain" />
                        </div>

                        {/* RIGHT: text area */}
                        <div className="flex-[0_0_50%] min-w-[260px] md:pr-5 text-justify">
                            <p className="text-gray-600 text-sm mb-4">
                                The concept of Lean Transformation of SMEs focuses on enhancing the processes across the value stream to eliminate waste and deliver optimized value to the customer. In 2017, a symbiosis between industry and academia, based on the concept of Lean Transformation, was introduced under the name of Visionary Learning Community of India (VLCI). VLCI is conceptualized to form a joint venture between learning communities of SMEs (Industry) and Engineering Colleges (academia), involving faculty and students to create a pipeline of engineering talent who can work with these SMEs in this transformative journey.
                            </p>
                            <p className="text-gray-600 text-sm mb-4">
                                LMP, under the aegis of VLCI, is based on the concepts of Lean Principles that will create future change leaders in the form of Engineering Graduates, leading to a sustainable industry. This initiative enables organizations to achieve their goals in smarter, more sustainable ways. The initiative of VLCI has embarked on a vision to transform the manufacturing industry through manufacturing change leaders (students) skilled in Lean Manufacturing Practices (LMP).
                            </p>
                        </div>
                    </div>
                </section>
                <section className="flex justify-center py-0 px-5 md:px-10 lg:px-16 ">
                    <img src="/assets/about-mijsc/flowchart.jpg" className='w-full md:w-[50%]' alt="LMP Flowchart" />
                </section>

                <section className="md:py-16 py-0 px-5 md:px-10 lg:px-16 bg-white ">
                    <div className="mx-auto">
                        <div className="text-center mb-14">
                            <h2 className="md:text-5xl   text-gray-800 mb-4">
                                LMP Course Structure
                            </h2>
                        </div>
                        <div className="bg-[#05976a] text-white rounded-xl py-2 shadow-3xl hover:shadow-xl transition-shadow duration-300 flex flex-col w-full">
                            <h3 className="text-md text-xl uppercase text-center">LMP Phase 1</h3>
                        </div>

                        <div className="w-full flex justify-center">
                            <div className="bg-[#05976a] my-4 text-white rounded-xl py-2 shadow-3xl hover:shadow-xl transition-shadow duration-300 flex flex-col w-[95%]">
                                <h3 className="text-md text-xl uppercase text-center">LMP Phase 2</h3>
                            </div>
                        </div>
                        <div className="w-full flex justify-center">
                            <div className="bg-[#05976a] text-white rounded-xl py-2 shadow-3xl hover:shadow-xl transition-shadow duration-300 flex flex-col w-[90%]">
                                <h3 className="text-md  text-xl uppercase text-center">LMP Phase 3</h3>
                            </div>
                        </div>
                        <div className="mt-14 border-2 border-dashed border-teal-500/70 rounded-xl p-6 md:p-8 bg-white shadow-sm">
                            <div className="overflow-x-auto">
                                <table className="border-separate border-spacing-y-3 w-full text-[15px]">
                                    <thead>
                                        <tr>
                                            <th className="border px-5 py-4 text-left font-semibold">
                                                COURSES
                                            </th>
                                            <th className="border px-5 py-4 text-left font-semibold">
                                                PHASE
                                            </th>
                                            <th className="border px-5 py-4 text-center font-semibold">
                                                Module 1
                                            </th>
                                            <th className="border px-5 py-4 text-center font-semibold">
                                                Module 2
                                            </th>
                                            <th className="border  px-5 py-4 text-center font-semibold">
                                                Module 3
                                            </th>
                                            <th className="border  px-5 py-4 text-center font-semibold">
                                                Module 4
                                            </th>
                                            <th className="border  px-5 py-4 text-center font-semibold">
                                                Module 5
                                            </th>
                                            <th className="border  px-5 py-4 text-center font-semibold">
                                                Module 6
                                            </th>
                                        </tr>
                                    </thead>


                                    <tbody className="text-gray-800">
                                        <tr className="hover:bg-teal-50/60 transition-colors">
                                            <td className="border border-gray-300 px-5 py-5 font-medium">
                                                Foundations of Lean Manufacturing Practices
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5">
                                                PHASE 1
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center">
                                                Observation Skills
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Evolution of Manufacturing
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center">
                                                Factory Concepts
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Understanding Lean Operations
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Flow Management System
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Mapping Material Flow
                                            </td>
                                        </tr>


                                        <tr className="hover:bg-teal-50/60 transition-colors">
                                            <td className="border border-gray-300 px-5 py-5 font-medium">
                                                Advanced Lean Manufacturing Practices
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5">
                                                PHASE 2
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center">
                                                Advanced Observation Skills
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Mapping Material and Information Flow
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center">
                                                Production Planning
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Production Control
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Standardised Work
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Shop Floor Leadership
                                            </td>
                                        </tr>


                                        <tr className="hover:bg-teal-50/60 transition-colors">
                                            <td className="border border-gray-300 px-5 py-5 font-medium">
                                                Consult to Compete
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5">
                                                PHASE 3
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center">
                                                Observation: Identifying Blockages
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Addressing Blockages: Quality
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center">
                                                Addressing Blockages: Quality
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Addressing Blockages: Human Skills
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Addressing Blockages: Soft Skills
                                            </td>
                                            <td className="border border-gray-300 px-5 py-5 text-center font-medium text-teal-700">
                                                Value Addition
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>
                            </div>

                        </div>
                    </div>
                </section>




            </div>

        </section>
    )
}

export default AboutLmp
